module.exports = __webpack_public_path__ + "static/img/model_bg@2x.4185321c.png";